import { render } from "./account-forms.vue?vue&type=template&id=5f14cac7"
import script from "./account-forms.vue?vue&type=script&lang=js"
export * from "./account-forms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__